import content from 'content.json';
import { FC, useMemo } from 'react';
import { parseCoreUser } from 'services/utils/user-utils';
import { useBookingStore } from 'store/booking/reducer';
import styled from 'styled-components';
import { BookingType, loyalType } from 'types/booking';

import SocialIcons from './components/SocialIcons';

const { inbox } = content;

const LoyaltyImage = styled.img`
  width: 24px;
  height: 24px;
  margin-left: 8px;
  vertical-align: middle;
`;

interface ClientName {
    client: any;
    selected: BookingType | null;
    priceModel: string;
}

const ClientName: FC<ClientName> = ({ client, selected, priceModel }) => {
    const { fullName } = useMemo(
        () => parseCoreUser(client),
        [client]
    );
    const bookingMetadata = useBookingStore((store) => store.bookingMetadata);
    const getPlanName = (plan: number | undefined) =>
        plan != undefined ? bookingMetadata.plans[plan].text : null;

    const getPlan = () => {
        if (selected && getPlanName(selected?.session.plan)) {
            const planClassName = getPlanName(selected?.session.plan);
            return (
                <div className={`client-plan ${planClassName}`}>
                    {getPlanName(selected?.session.plan)} {priceModel}
                </div>
            );
        }
    };

    return (
        <div className="client-info">
            <label className="client-name">{fullName}</label>
            {selected?.client?.loyalty && (
                <LoyaltyImage
                    className="loyalty"
                    src={inbox.icons[selected.client.loyalty as loyalType]}
                    alt='Loyalty icon'
                />
            )}
            {getPlan()}
            <SocialIcons client={client} />
        </div>
    );
};
export default ClientName;
